import { Button, Input, Switch } from "antd";
import CustomTable from "components/CustomTable";
import PageHeader from "components/PageHeader";
import { PAGE_SIZE_DEFAULT } from "features/ProjectType/core";
import { mapProjectType } from "features/ProjectType/data/mappers";
import ProjectTypeFormModal from "features/ProjectType/presentation/components/ProjectTypeFormModal";
import { ProjectTypeState } from "features/ProjectType/presentation/components/ProjectTypeState";
import { Link } from "react-router-dom";
import useProjectTypeList from "./useProjectTypeList";
import "./index.scss";
export default function ProjectTypeList() {
  const vm = useProjectTypeList();
  const columns = [
    {
      title: "STT",
      width: 60,
      align: "center",
      render: (_, record, index) => (vm.page - 1) * PAGE_SIZE_DEFAULT + index + 1,
    },
    {
      title: "TÊN LOẠI DỰ ÁN",
      dataIndex: "name",
      render: (name, record) => <Link to={`/setting/project-type/${record.id}`}>{name}</Link>,
    },
    {
      title: "SỐ GÓI ĐỀ XUẤT",
      width: 150,
      align: "center",
      dataIndex: "visiblePackageTierCount",
      render: (count) => `${count}/4 mức`,
    },
    { title: "THỨ TỰ", width: 90, align: "center", dataIndex: "displayOrder" },
    { title: "CẬP NHẬT LẦN CUỐI", width: 170, align: "center", dataIndex: "updatedAtLabel" },
    { title: "NGƯỜI CẬP NHẬT", width: 150, align: "center", dataIndex: "updatedByLabel" },
    {
      title: "HÀNH ĐỘNG",
      width: 150,
      align: "center",
      render: (_, record) => (
        <Switch
          aria-label={`Hiển thị ${record.name}`}
          checked={record.isVisible}
          disabled={vm.saving}
          onChange={(value) => vm.changeVisibility(record, value)}
        />
      ),
    },
  ];
  return (
    <div className="project-type-page">
      <PageHeader
        pageTitle="Cấu hình loại dự án"
        routes={[{ name: "Cài đặt hệ thống", path: "/setting" }, { name: "Cấu hình loại dự án" }]}
      />
      <div className="project-type-card">
        <div className="project-type-toolbar">
          <Input
            className="project-type-search"
            allowClear
            placeholder="Tìm kiếm theo tên loại dự án..."
            value={vm.keyword}
            onChange={(event) => vm.setKeyword(event.target.value)}
          />
          <Button type="primary" onClick={() => vm.setModalOpen(true)}>
            + Thêm mới loại dự án
          </Button>
        </div>
        <ProjectTypeState {...vm}>
          <CustomTable
            rowKey="id"
            columns={columns}
            dataSource={(vm.data?.items || []).map(mapProjectType)}
            locale={{ emptyText: vm.keyword.trim() ? "Không tìm thấy loại dự án phù hợp" : "Chưa có loại dự án nào" }}
            pagination={{
              current: vm.page,
              pageSize: PAGE_SIZE_DEFAULT,
              total: vm.data?.total || 0,
              showSizeChanger: false,
              onChange: vm.setPage,
            }}
          />
        </ProjectTypeState>
      </div>
      {vm.modalOpen && <ProjectTypeFormModal onClose={() => vm.setModalOpen(false)} onSaved={vm.onSaved} />}
    </div>
  );
}
